<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经销商">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'dealerName',
                {
                  rules: [{ required: false, message: '' }],
                  initialValue: data.dealerName,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销售组织">
            <a-select
              placeholder=""
              :disabled="true"
              :options="this.organizationOptions"
              v-decorator="[
                'organizationId',
                {
                  initialValue: data.organizationId,
                  rules: [{ required: false, message: '请选择销售组织' }],
                },
              ]"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="部门">
            <a-select
              placeholder=""
              :options="this.departmentOptions"
              :disabled="true"
              v-decorator="[
                'departmentId',
                {
                  initialValue: data.departmentId,
                  rules: [{ required: false, message: '请选择部门' }],
                },
              ]"
            ></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="销售员">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'saleEmployeeName',
                {
                  rules: [{ required: false, message: '请选择销售员' }],
                  initialValue: data.saleEmployeeName,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'contact',
                {
                  rules: [{ required: false, message: '请输入联系人' }],
                  initialValue: data.contact,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'telephone',
                {
                  rules: [{ required: false, message: '请输入联系电话' }],
                  initialValue: data.telephone,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货地址">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'detailAddress',
                {
                  initialValue: data.detailAddress,
                  rules: [{ required: false, message: '请输入详细地址' }],
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货方式">
            <a-select
              placeholder=""
              :disabled="true"
              v-decorator="[
                'deliveryMethod',
                {
                  initialValue: data.deliveryMethod,
                  rules: [{ required: false, message: '请选择发货方式' }],
                },
              ]"
            >
              <a-select-option value="0">零担</a-select-option>
              <a-select-option value="1">整车</a-select-option>
              <a-select-option value="2">自提</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="货运部">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'freightName',
                {
                  rules: [{ required: false, message: '请输入货运部' }],
                  initialValue: data.freightTelephone,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="货运部电话">
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="[
                'freightTelephone',
                {
                  rules: [{ required: false, message: '请输入货运部电话' }],
                  initialValue: data.freightTelephone,
                },
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <!-- <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="信用额度">
            <label>{{availableBalance}}</label>
          </a-form-item>
        </a-col>-->
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="订单金额">
            <label>{{ totalAmount }}</label>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="17">
          <a-form-item
            :labelCol="{
              xs: { span: 24 },
              sm: { span: 2 },
            }"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 22 },
            }"
            label="前台备注"
          >
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="['frontNotes', { initialValue: data.frontNotes }]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="17">
          <a-form-item
            :labelCol="{
              xs: { span: 24 },
              sm: { span: 2 },
            }"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 22 },
            }"
            label="后台备注"
          >
            <a-input
              :read-only="true"
              placeholder=""
              v-decorator="['backNotes', { initialValue: data.backNotes }]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider orientation="left" style="font-size: 14px">审核信息</a-divider>
      <a-row class="form-row" :gutter="24">
        <a-col :span="17">
          <a-form-item
            :labelCol="{
              xs: { span: 24 },
              sm: { span: 2 },
            }"
            :wrapperCol="{
              xs: { span: 24 },
              sm: { span: 22 },
            }"
            label="审核说明"
          >
            <a-input
              :read-only="this.params.isShow"
              placeholder=""
              v-decorator="['auditNotes', { initialValue: data.auditNotes }]"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="6">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="审核结果">
            <a-radioGroup
              placeholder="请选择审核结果"
              v-decorator="[
                'status',
                {
                  initialValue: data.status,
                  rules: [{ required: true, message: '请选择审核结果' }],
                },
              ]"
            >
              <a-radio value="1">通过</a-radio>
              <a-radio value="0">不通过</a-radio>
            </a-radioGroup>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="24">
          <a-table
            :columns="productColumns"
            :dataSource="productList"
            bordered
            :pagination="false"
            :scroll="{ x: this.itemTableWidth }"
            :rowKey="
              (record) => {
                return record.id;
              }
            "
          >
            <template slot="price" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="
                    record.editable &&
                    record.isBom == false
                  "
                  style="margin: -5px 0"
                  :value="text"
                  type="number"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'price')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="quantity" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="record.editable && record.parentProductId == 0"
                  style="margin: -5px 0"
                  :value="text"
                  type="number"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'quantity')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="notes" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="
                    record.editable &&
                    (record.parentProductId > 0 || !record.isBom)
                  "
                  style="margin: -5px 0"
                  :value="text"
                  type="text"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'notes')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="lotNumber" slot-scope="text, record, index">
              <div>
                <a-input
                  v-if="
                    record.editable &&
                    (record.parentProductId > 0 || !record.isBom)
                  "
                  style="margin: -5px 0"
                  :value="text"
                  type="text"
                  @change="
                    (e) => productChange(e.target.value, record.id, 'lotNumber')
                  "
                />
                <template v-else>{{ text }}</template>
              </div>
            </template>
            <template slot="dealerExpectedDeliveryDate" slot-scope="text, record, index">
              <div>
                <a-date-picker
                  v-if="record.editable && record.parentProductId == 0"
                  format="YYYY-MM-DD"
                  :disabledDate="
                    (current) =>
                      disabledDate(current, record.expectedDeliveryDate)
                  "
                  @change="
                    (date, dateString) =>
                      productChange(
                        date,
                        record.id,
                        'dealerExpectedDeliveryDate'
                      )
                  "
                />
                <template v-else>
                  {{
                  record.parentProductId == 0
                  ? formatDate(
                  record.dealerExpectedDeliveryDate,
                  "YYYY-MM-DD"
                  )
                  : ""
                  }}
                </template>
              </div>
            </template>
            <template slot="activity" slot-scope="text, record, index">
              <div>
                <template>{{ record.activityName }}</template>
              </div>
            </template>
            <template slot="operation" slot-scope="text, record, index">
              <div class="editable-row-operations">
                <span v-if="record.editable">
                  <a @click="() => save(record.id, record.parentProductId)">保存</a>
                </span>
                <span v-else>
                  <a @click="() => edit(record.id, record.parentProductId)">编辑</a>
                </span>
              </div>
            </template>
            <template slot="isProcess" slot-scope="text, record, index">
              <span>
                <a-checkbox
                  :defaultChecked="
                    record.isProcess != null ? record.isProcess : false
                  "
                  @change="(e) => onChange(e.target, record.id, 'isProcess')"
                >是否加工</a-checkbox>
              </span>
            </template>
          </a-table>
        </a-col>
      </a-row>
      <div class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left: 10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
import { constants } from "zlib";
import { setTimeout } from "timers";
const defaultData = {
  id: 0,
  dealerId: null,
  dealerName: "",
  dealerPhone: "",
  activityId: undefined,
  activityName: "",
  backNotes: "",
  salesId: "",
  salesName: "",
  provinceId: "",
  cityId: "",
  districtId: "",
  detailAddress: "",
  useCouponId: undefined,
  couponAmount: "",
  items: []
};

export default {
  name: "hp-manager-page-ordermaster-audit",
  components: {},
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },

  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      productColumns: [
        {
          title: "操作",
          dataIndex: "operation",
          width: 80,
          scopedSlots: { customRender: "operation" },
          fixed: "left"
        },
        {
          title: "产品名称",
          dataIndex: "productName",
          width: 200
        },
        {
          title: "产品编码",
          dataIndex: "productCode",
          width: 100
        },
        {
          title: "规格",
          dataIndex: "specDes",
          width: 160
        },
        {
          title: "定制",
          dataIndex: "isCustom",
          width: 70,
          customRender: (text, row, index) => {
            return row.isCustom ? "是" : "否";
          }
        },
        {
          title: "数量",
          dataIndex: "quantity",
          width: 100
        },
        {
          title: "价格",
          dataIndex: "price",
          width: 100,
          scopedSlots: { customRender: "price" }
        },
        {
          title: "是否加工",
          dataIndex: "isProcess",
          scopedSlots: { customRender: "isProcess" },
          width: 120
        },
        {
          title: "是否欠货",
          dataIndex: "isInsufficient",
          width: 100,
          customRender: (text, row, index) => {
            return row.isInsufficient ? "欠货" : "有货";
          }
        },
        {
          title: "加工工艺",
          dataIndex: "notes",
          scopedSlots: { customRender: "notes" },
          width: 200
        },
        {
          title: "批号",
          dataIndex: "lotNumber",
          scopedSlots: { customRender: "lotNumber" },
          width: 160
        },
        {
          title: "套件",
          dataIndex: "isBom",
          width: 70,
          customRender: (text, row, index) => {
            return row.isBom ? "是" : "否";
          }
        },
        {
          title: "预计交期",
          dataIndex: "expectedDeliveryDate",
          width: 100,
          customRender: (text, row, index) => {
            return this.formatDate(row.expectedDeliveryDate, "YYYY-MM-DD");
          }
        },
        {
          title: "要货日期",
          dataIndex: "dealerExpectedDeliveryDate",
          width: 140,
          scopedSlots: { customRender: "dealerExpectedDeliveryDate" }
        },
        {
          title: "活动",
          dataIndex: "activityId",
          width: 200,
          scopedSlots: { customRender: "activity" }
        },
        {
          title: "活动价",
          dataIndex: "activityPrice",
          width: 100
        }
      ],
      addressOptions: config.addressJson,
      defaultValue: [],
      searchOption: [],
      fileList: [],
      dealerList: [],
      activityOptions: [],
      salesUserOption: [],
      couponOptions: [],
      departmentOptions: [],
      organizationOptions: [],
      selectVisible: false,
      productList: [],
      isInsufficientList: [],
      productIds: [],
      cacheData: [],
      selectEmployeeParams: null,
      selectProductParams: null,
      modalWidth: "1000px",
      dealerVisible: false,
      selectEmployeeVisible: false,
      dealerId: null,
      availableBalance: null,
      saleEmployeeId: null,
      itemTableWidth: 0
    };
  },
  computed: {
    totalAmount: function() {
      let a = 0;
      if (this.productList) {
        this.productList.forEach(q => {
          if (q.parentProductId == 0) {
            a = a + q.quantity * q.price;
          }
        });
      }
      return Number(a).toFixed(2);
    }
  },
  async mounted() {
    if (this.params.id) {
      await this.getdetailOrder();
    } else {
      this.data = exzends(defaultData);
    }
    this.productColumns.forEach(x => {
      this.itemTableWidth += x.width;
    });
  },

  methods: {
    edit(key, parentProductId) {
      const newData = [...this.productList];
      const target = newData.filter(
        item =>
          //key === item.productId && item.parentProductId === parentProductId
          key === item.id
      )[0];
      console.log("Edit-----", target);
      if (target) {
        target.editable = true;
        this.productList = newData;
      }
      console.log("ProductList----------------", this.productList);
    },
    save(key, parentProductId) {
      const newData = [...this.productList];
      const target = newData.filter(
        item =>
          //key === item.productId && item.parentProductId === parentProductId
          key === item.id
      )[0];
      if (target) {
        if ((target.price || 0) < 0) {
          this.$message.warn("价格不正确，请检查");
          return;
        }
        delete target.editable;
        this.productList = newData;
        this.cacheData = newData.map(item => ({ ...item }));
        this.updateItem(target);
      }
    },
    updateItem(element) {
      console.log(element);
      api
        .UpdateOrderItem({
          id: element.id,
          price: element.price,
          notes: element.notes,
          isProcess: element.isProcess,
          lotNumber: element.lotNumber,
          dealerExpectedDeliveryDate:
            element.dealerExpectedDeliveryDate != null
              ? element.dealerExpectedDeliveryDate.startOf("day").valueOf()
              : undefined
        })
        .then(res => {
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    onChange(target, key, column) {
      const newData = [...this.productList];
      //const product = newData.filter((item) => key === item.productId)[0];
      const product = newData.filter(item => key === item.id)[0];
      if (product) {
        product[column] = target.checked;
        this.productList = newData;
      }
    },

    productChange(value, key, column) {
      const newData = [...this.productList];
      //const target = newData.filter((item) => key === item.productId)[0];
      const target = newData.filter(item => key === item.id)[0];
      if (target) {
        target[column] = value;
        this.productList = newData;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    disabledDate(current, expectedDeliveryDate) {
      return expectedDeliveryDate == null
        ? current && current < moment().endOf("day")
        : current && current < expectedDeliveryDate;
    },
    async getOrganizationOptions(dealerId) {
      let orgList = await api.GetOrganizationSelectByDealerId({
        dealerId: dealerId
      });
      if (orgList) {
        orgList.forEach(a => {
          this.organizationOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
    },

    async getDepartmentOptions(orgId) {
      let departmentList = await api.GetDepartmentSelect({
        orgId: orgId,
        dealerId: this.dealerId
      });
      if (departmentList) {
        departmentList.forEach(a => {
          this.departmentOptions.push({
            label: a.text,
            value: a.value
          });
        });
      }
      let x = departmentList.filter(x => x.selected == true)[0];
      if (x) {
        this.form.setFields({
          departmentId: { value: x.value, errors: null }
        });
      }
    },

    async getAvailableBalanceByDealerId(dealerId, orgId) {
      this.availableBalance = 0;
      let result = await api.GetAvailableBalanceByDealerId({
        dealerId: dealerId,
        organizationId: orgId
      });
      if (result != null) {
        this.availableBalance = Number(result).toFixed(2);
      }
    },

    async getdetailOrder() {
      this.loading = true;
      let result = await api.GetOrderMaster({ orderMasterId: this.params.id });
      if (result) {
        this.data = result;
        this.defaultValue = [
          this.data.provinceId + "",
          this.data.cityId + "",
          this.data.districtId + ""
        ];
        // if (this.data.orderType != 1) {
        //   this.productColumns = this.productColumns.filter(
        //     a => a.dataIndex != "operation"
        //   );
        // }
        this.data.status = "1";
        this.dealerId = this.data.dealerId;
        this.saleEmployeeId = this.data.saleEmployeeId;
        await this.getOrganizationOptions(this.data.dealerId);
        await this.getDepartmentOptions(this.data.organizationId);
        await this.getAvailableBalanceByDealerId(
          this.dealerId,
          this.data.organizationId
        );
        this.data.organizationId = this.data.organizationId + "";
        if (this.data.departmentId > 0) {
          this.data.departmentId = this.data.departmentId + "";
        } else {
          this.data.departmentId = undefined;
        }
        this.data.deliveryMethod = this.data.deliveryMethod + "";
        let tempList = this.data.items.filter(
          a => a.parentProductId == null || a.parentProductId == 0
        );

        // this.productList = this.data.items;
        tempList.forEach(a => {
          if (a.dealerExpectedDeliveryDate) {
            a.dealerExpectedDeliveryDate = new moment(
              a.dealerExpectedDeliveryDate
            );
            a.parentProductId = 0;
            this.productList.push(a);
            this.productIds.push(a.productId);
            let chList = this.data.items.filter(
              y => a.productId == y.parentProductId && y.parentProductId > 0
            );
            if (chList.length > 0) {
              chList.forEach(x => {
                x.productName = "【子件】" + x.productName;
                x.childQuantity = x.quantity / a.quantity;
                if (x.dealerExpectedDeliveryDate) {
                  x.dealerExpectedDeliveryDate = new moment(
                    x.dealerExpectedDeliveryDate
                  );
                }
                this.productList.push(x);
              });
            }
          }
        });
      }
      var inventory = await api.GetInventory({
        organizationId: this.form.getFieldValue("organizationId"),
        productIdList: this.productIds
      });
      this.isInsufficientList = inventory.items;
      if (this.isInsufficientList != null) {
        this.isInsufficientList.forEach(n => {
          this.productList.forEach(a => {
            if (n.productId == a.productId) {
              a.isInsufficient = n.quantity < a.quantity;
            }
          });
        });
      }

      this.loading = false;
    },

    dataToPostData(value) {
      let result = {
        id: this.data.id,
        auditNotes: value.auditNotes,
        status: value.status,
        deliveryMethod: value.deliveryMethod,
        items: []
      };
      this.productList.forEach(element => {
        result.items.push({
          id: element.id,
          price: element.price,
          notes: element.notes,
          isProcess: element.isProcess,
          lotNumber: element.lotNumber,
          dealerExpectedDeliveryDate:
            element.dealerExpectedDeliveryDate != null
              ? element.dealerExpectedDeliveryDate.startOf("day").valueOf()
              : undefined
        });
        console.log(element);
      });
      return result;
    },

    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        console.log(requestData);
        let data = await api.AuditOrderMaster(requestData);
        if (data) {
          this.$message.success("审核成功");
          var res = await api.SubmitOrderToErp({ id: requestData.id });
          if (res) {
            this.$emit("submit-success");
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Orders/OrderMaster/Audit.vue